export default {
  API_URL: import.meta.env.VITE_API_URL,
  ADMIN_URL: import.meta.env.VITE_ADMIN_URL,
  SSO_URL: import.meta.env.VITE_SSO_URL,
  REPORT_CRASHES: import.meta.env.VITE_REPORT_CRASHES === "true",
};
